<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" :rules="formRules" ref="queryForm" :inline="true">
          <div class="flex-box">
            <img src="../../../assets/down.png" class="down" alt="">

            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{query.timeType === 1?'日':(query.timeType === 2?'周':'月')}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">日</el-dropdown-item>
                <el-dropdown-item command="3">月</el-dropdown-item>
                <el-dropdown-item command="2">周</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form-item label="距离服务时间：" class="is-required" prop="day" style="display:flex">
              <el-input placeholder="请输入" v-model="query.day" size="small" class="input-with-select" />

            </el-form-item>
          </div>
          <el-form-item label="客户信息：" class="is-required">
            <el-select v-model="query.customerId" placeholder="请选择" filterable clearable size="small" :filter-method="filterOptions">
              <el-option v-for="(item,index) in customerOptions" :key="index" :label="item.name + '(' + item.pho +')'" :value="item.customerId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会议类型：" class="is-required">
            <el-select v-model="query.meetType" placeholder="请选择" clearable size="small">
              <el-option label="义诊" :value="1"></el-option>
              <el-option label="闯关模式" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <echarts-vue :echart-data="echartData" echartName="echarts" v-if="echartData && echartData.yAxisData" />
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import DataBoardApi from '@/api/dataBoard/DataBoard'
import echartsVue from "../components/echarts.vue";
import { debounce } from 'lodash';
export default {
  components: {
    Pagination,
    echartsVue
  },
  data() {
    return {
      list: [],
      listLoading: true,
      total: 0,
      query: {
        timeType: 1
      },
      customerOptions: [],
      echartsData: [],
      xData: [],
      formRules: {
        day: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }]
      }
    }
  },
  created() {
    // this.getEcharts()
    this.getCustomerList()
  },
  methods: {
    handleCommand(command) {
      this.query.timeType = +command
    },
    handleQuery() {
      let { day, timeType, customerId, meetType } = this.query;
      if (!day) return this.$message.warning('请输入距离服务时间')
      if (!timeType) return this.$message.warning('请选择时间粒度')
      if (!customerId) return this.$message.warning('请选择客户信息')
      if (!meetType) return this.$message.warning('请选择会议类型')
      this.doQueryList()
    },
    doQueryList() {
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.query))
          params.day = params.day ? +params.day : undefined
          DataBoardApi.findServiceAnalysisStatistics(params).then(({ data }) => {
            if (data.length > 0) {
              this.calcDate(data)
              this.getEcharts(data)
            } else {
              this.$message.warning('暂无数据')
            }
          })
        }
      })
    },
    calcDate(data) {
      let { timeType } = this.query;
      let dateList = []
      if (timeType === 1) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      } else if (timeType === 2) {
        data.forEach((item, index) => {
          let date = item.startTime.substr(0, 10).replace(/\-/g, "/")
          dateList.push(`第${index + 1}周 ${date}`)
        });

      } else if (timeType === 3) {
        data.forEach(item => {
          item.date = item.startTime.substr(0, 7).replace(/\-/g, "/")
        });
        dateList = data.map(item => item.date)
      }
      this.xData = dateList
    },
    filterOptions: debounce(function (query) {
      // 这里进行接口调用或数据过滤操作
      this.getCustomerList(query)
    }, 300),
    getCustomerList(query) {
      let params = {
        pageNo: 1,
        pageSize: 100
      }
      if (query) params.nameOrPho = query
      DataBoardApi.findDesignatedCustomers(params).then(res => {
        this.customerOptions = res.data.list
      })
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "收款", color: "#FED15C", key: "money" },
        { name: "出货", color: "#F3715B", key: "num" },
      ], "line")
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 10 };
      }
      return ydata.map(item => {
        return {
          name: item.name, ...param, data: datalist.map(it => it[item.key]), itemStyle: {
            ...itemStyle,
            color: item.color
          }
        }
      })
    }

  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    }
  },
}
</script>
<style lang="scss" scoped>
.down {
  width: 34px;
  height: 34px;
  margin-right: 10px;
  cursor: pointer;
}
.flex-box {
  display: flex;
  flex-direction: row-reverse;
}
.el-dropdown {
  line-height: 42px;
  margin-right: 10px;
}
</style>
